<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-text">
          <h4 class="title">
            Statutory Inspection Items
          </h4>
        </div>
        <add-button
          :visible="isEditable"
          @add-click="createStatInspItem"
        ></add-button>
      </md-card-header>
      <md-card-content>
        <md-table
          v-model="statInspItemList"
          class="table-striped"
          table-header-color="primary"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell>
              <Badge :type="status(item.statInspItemStatusId).colour">{{
                status(item.statInspItemStatusId).name
              }}</Badge>
            </md-table-cell>
            <md-table-cell>
              <md-icon v-if="item.isChargeable">attach_money</md-icon>
              <md-tooltip>Is Chargeable</md-tooltip>
            </md-table-cell>
            <md-table-cell>
              <md-icon v-if="item.hasNotes">question_answer</md-icon>
              <md-tooltip>Has Notes</md-tooltip>
            </md-table-cell>
            <md-table-cell md-label="Type">
              {{ type(item.statInspItemTypeId) }}
            </md-table-cell>
            <md-table-cell md-label="Description">
              {{ item.description }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                v-if="canDelete(item)"
                class="md-just-icon md-danger"
                @click="deleteItem(item.id)"
              >
                <md-icon>delete</md-icon>
              </md-button>
              &nbsp;
              <md-button
                class="md-just-icon md-primary"
                @click="viewItem(item.id)"
              >
                <md-tooltip>View Stat Insp Item</md-tooltip>
                <md-icon>forward</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state
            >No Statutory Inspection Items Found</md-table-empty-state
          >
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Badge } from "@/components";
import Swal from "sweetalert2";
export default {
  components: {
    Badge
  },
  computed: {
    ...mapGetters({
      statInspItemList: "stat-insp/statInspItems",
      isEditable: "stat-insp/isEditable",
      status: "stat-insp/statInspItemStatus",
      type: "stat-insp/statInspItemType"
    })
  },
  methods: {
    async createStatInspItem() {
      await this.$router.push({
        name: "Create Stat Insp Item",
        params: { statInspId: this.$route.params.statInspId }
      });
    },
    async viewItem(id) {
      await this.$router.push({
        name: "Stat Insp Item View",
        params: { statInspItemId: id }
      });
    },
    canDelete(item) {
      return (
        item.isDeleteable && this.isEditable && this.$auth.isInGlobalRole()
      );
    },
    deleteItem(id) {
      Swal.fire({
        text: `Are you sure you want to delete this item?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("stat-insp/deleteStatInspItem", id)
            .then(() => {})
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    }
  }
};
</script>

<style></style>
